import { valueCards } from '@/mocks/homeData';

const colorMap: Record<string, { bg: string; iconBg: string; text: string; title: string }> = {
  primary: {
    bg: 'bg-primary-50',
    iconBg: 'bg-primary-100',
    text: 'text-primary-600',
    title: 'text-primary-900',
  },
  accent: {
    bg: 'bg-accent-50',
    iconBg: 'bg-accent-100',
    text: 'text-accent-600',
    title: 'text-accent-900',
  },
  secondary: {
    bg: 'bg-secondary-50',
    iconBg: 'bg-secondary-100',
    text: 'text-secondary-600',
    title: 'text-secondary-900',
  },
};

export default function ValueSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block text-xs font-medium tracking-widest uppercase text-primary-600 bg-primary-100/60 px-4 py-1.5 rounded-full mb-4">
            品牌核心
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            以心相伴，品质如一
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            久久伊人始终坚守三大核心价值，为每一位用户带来温暖而持久的情感陪伴体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-5xl mx-auto">
          {valueCards.map((card) => {
            const colors = colorMap[card.color];
            return (
              <div
                key={card.id}
                className={`group ${colors.bg} rounded-lg p-8 md:p-10 text-center transition-all duration-300 hover:scale-[1.02]`}
              >
                <div className={`w-16 h-16 mx-auto mb-5 flex items-center justify-center rounded-full ${colors.iconBg}`}>
                  <i className={`${card.icon} text-2xl ${colors.text}`} />
                </div>
                <h3 className={`font-heading text-lg md:text-xl font-semibold mb-3 ${colors.title}`}>
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {card.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}